import { AsyncComponent } from '@/utils/asyncComponent'

export const asyncRouterMap = [
  {
    path: '/clientMap',
    component: () => AsyncComponent(import('@/views/home/Index')),
    name: 'clientMap',
    meta: {
      keepAlive: true,
      isUseCache: false,
      title: '终端查询',
      permissions: ['PHONE_CLIENT_MAP']
    }
  },
  // 终端拜访地图
  {
    path: '/visitMap',
    component: () =>
      AsyncComponent(import('@/views/terminalVisit/terminalVisitMap')),
    name: 'terminalVisitMap',
    meta: {
      keepAlive: true,
      isUseCache: false, // 不使用缓存
      title: '终端拜访',
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  // 拜访地图
  {
    path: '/mapDrive',
    component: () =>
      AsyncComponent(import('@/views/terminalVisit/mapDrive')),
    name: 'mapDrive',
    meta: {
      title: '地图组件',
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  {
    path: '/channel',
    component: () => AsyncComponent(import('@/views/analyse/channel')),
    name: 'channel',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '渠道',
      permissions: ['PHONE_JIANMIN_CHANNEL_ANALYSE']
    }
  },
  {
    path: '/province-sales',
    component: () =>
      AsyncComponent(import('@/views/analyse/province-sales')),
    name: 'provinceSales',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '省区销售',
      permissions: ['PHONE_JIANMIN_COUNTRY_ANALYSE']
    }
  },
  {
    path: '/dept-sales',
    component: () => AsyncComponent(import('@/views/analyse/dept-sales')),
    name: 'deptSales',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '部门销售',
      permissions: ['PHONE_JIANMIN_DEPT_ANALYSIS']
    }
  },
  {
    path: '/product-cover-by-province',
    component: () =>
      AsyncComponent(import('@/views/analyse/product-cover-by-province')),
    name: 'productCoverByProvince',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '终端覆盖',
      permissions: ['PHONE_JIANMIN_COUNTRY_ANALYSE']
    }
  },
  {
    path: '/product-cover-by-city',
    component: () =>
      AsyncComponent(import('@/views/analyse/product-cover-by-city')),
    name: 'productCoverByCity',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '终端覆盖',
      permissions: ['PHONE_JIANMIN_PROVINCE_ANALYSIS']
    }
  },
  {
    path: '/product-cover-by-dept',
    component: () =>
      AsyncComponent(import('@/views/analyse/product-cover-by-dept')),
    name: 'productCoverByDept',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '终端覆盖',
      permissions: ['PHONE_JIANMIN_DEPT_ANALYSIS']
    }
  },
  {
    path: '/product-distribution-by-province',
    component: () =>
      AsyncComponent(
        import('@/views/analyse/product-distribution-by-province')
      ),
    name: 'productDistributionByProvince',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '铺货',
      permissions: ['PHONE_JIANMIN_COUNTRY_ANALYSE']
    }
  },
  {
    path: '/product-standards-by-province',
    component: () =>
      AsyncComponent(
        import('@/views/analyse/product-standards-by-province')
      ),
    name: 'productStandardsByProvince',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '达标',
      permissions: ['PHONE_JIANMIN_COUNTRY_ANALYSE']
    }
  },
  {
    path: '/countryAnalyse',
    component: () =>
      AsyncComponent(import('@/views/analyse/country-analyse')),
    name: 'countryAnalyse',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '全国分析',
      permissions: ['PHONE_JIANMIN_COUNTRY_ANALYSE']
    }
  },
  {
    path: '/provinceAnalyse',
    component: () =>
      AsyncComponent(import('@/views/analyse/province-analyse')),
    name: 'provinceAnalyse',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '省区分析',
      permissions: ['PHONE_JIANMIN_PROVINCE_ANALYSIS']
    }
  },
  // 部门分析
  {
    path: '/deptAnalyse',
    component: () =>
      AsyncComponent(import('@/views/analyse/department-analyse')),
    name: 'deptAnalyse',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '部门分析',
      permissions: ['PHONE_JIANMIN_DEPT_ANALYSIS']
    }
  },
  // 区域铺货
  {
    path: '/regionalDistribution',
    component: () => AsyncComponent(import('@/views/regionalDistribution')),
    name: 'regionalDistribution',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '区域铺货',
      permissions: [
        'PHONE_JIANMIN_PROVINCE_ANALYSIS',
        'PHONE_JIANMIN_DEPT_ANALYSIS'
      ]
    }
  },

  // 部门分析区域铺货
  {
    path: '/regionalDistribution/deptAreaDistribution',
    component: () =>
      AsyncComponent(
        import('@/views/regionalDistribution/deptAreaDistribution')
      ),
    name: 'deptAreaDistribution',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '区域铺货',
      permissions: ['PHONE_JIANMIN_DEPT_ANALYSIS']
    }
  },

  // 区域铺货下钻
  {
    path: '/regionalDistribution/districtDistribution',
    component: () =>
      AsyncComponent(
        import('@/views/regionalDistribution/districtDistribution')
      ),
    name: 'districtDistribution',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '区域铺货下钻',
      permissions: [
        'PHONE_JIANMIN_PROVINCE_ANALYSIS',
        'PHONE_JIANMIN_DEPT_ANALYSIS'
      ]
    }
  },
  // 大客户分析
  {
    path: '/keyAccountAnalysis',
    component: () => AsyncComponent(import('@/views/keyAccountAnalysis')),
    name: 'keyAccountAnalysis',
    meta: {
      keepAlive: true,
      isUseCache: false, // 不使用缓存
      title: '大客户分析',
      permissions: ['PHONE_JIANMIN_CUSTOMER_ANALYSIS']
    }
  },
  // 大客户分析列表明细-九州通
  {
    path: '/keyAccountAnalysis/jionTownDetail',
    component: () =>
      AsyncComponent(import('@/views/keyAccountAnalysis/joinTownDetail')),
    name: 'joinTownDetail',
    meta: {
      keepAlive: true,
      isUseCache: false,
      title: '大客户分析列表明细-九州通',
      permissions: ['PHONE_JIANMIN_CUSTOMER_ANALYSIS']
    }
  },
  // 大客户分析列表明细
  {
    path: '/keyAccountAnalysis/detail',
    component: () =>
      AsyncComponent(import('@/views/keyAccountAnalysis/detail')),
    name: 'detail',
    meta: {
      keepAlive: false,
      isUseCache: false,
      title: '大客户分析列表明细',
      permissions: ['PHONE_JIANMIN_CUSTOMER_ANALYSIS']
    }
  },

  // 购进详情
  {
    path: '/purchaseDetail',
    component: () => AsyncComponent(import('@/views/purchaseDetail')),
    name: 'purchaseDetail',
    meta: {
      title: '购进详情',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP']
    }
  },
  // 拜访填写
  {
    path: '/visitFill',
    component: () =>
      AsyncComponent(import('@/views/visitFill/submitVisit')),
    name: 'visitFill',
    meta: {
      title: '终端拜访',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  // 添加拜访
  {
    path: '/addVisit',
    component: () => AsyncComponent(import('@/views/visitFill/addVisit')),
    name: 'addVisit',
    meta: {
      title: '添加拜访',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_ADD']
    }
  },
  // 拜访信息提交成功
  {
    path: '/visitFill/visitSuccess',
    component: () =>
      AsyncComponent(import('@/views/visitFill/visitSuccess')),
    name: 'visitSuccess',
    meta: {
      title: '拜访信息提交成功',
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  {
    path: '/myVisit',
    component: () => AsyncComponent(import('@/views/visitRecords/myVisit')),
    name: 'myVisit',
    meta: {
      title: '我的拜访',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_MY_VISIT']
    }
  },
  {
    path: '/clientVisitRecords',
    component: () =>
      AsyncComponent(import('@/views/visitRecords/clientVisitRecords')),
    name: 'clientVisitRecords',
    meta: {
      title: '拜访记录',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  {
    path: '/visitDetail',
    component: () =>
      AsyncComponent(import('@/views/visitRecords/visitDetail')),
    name: 'visitDetail',
    meta: {
      title: '拜访详情',
      noRequiresAuth: true,
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    }
  },
  {
    path: '/feedbackMessage',
    component: () => import('@/components/TransferRouter'),
    meta: {
      title: '反馈',
      permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
    },
    children: [
      {
        path: '',
        name: 'feedbackMessage',
        component: () =>
          AsyncComponent(import('@/views/feedbackMessage')),
        meta: {
          title: '反馈',
          keepAlive: true,
          isUseCache: false,
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      },

      {
        // 已闭店
        path: 'closeStore',
        name: 'closeStore',
        component: () =>
          AsyncComponent(
            import('@/views/feedbackMessage/close-store')
          ),
        meta: {
          title: '已闭店',
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      },
      {
        // 电话、地址信息错误
        path: 'addDetail',
        component: () =>
          AsyncComponent(
            import('@/views/feedbackMessage/add-detail')
          ),
        name: 'addDetail',
        meta: {
          title: '电话、地址信息错误',
          keepAlive: true,
          isUseCache: false,
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      },
      {
        // 选择更换地图
        path: 'addressMap',
        component: () =>
          AsyncComponent(
            import('@/views/feedbackMessage/address-map')
          ),
        name: 'addressMap',
        meta: {
          title: '选择更换地图',
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      },
      {
        // 属性变更
        path: 'changeQuality',
        component: () =>
          AsyncComponent(
            import('@/views/feedbackMessage/change-quality')
          ),
        name: 'changeQuality',
        meta: {
          title: '属性变更',
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      },
      {
        // 反馈成功
        path: 'feedbackSuccess',
        component: () =>
          AsyncComponent(
            import('@/views/feedbackMessage/feedback-success')
          ),
        name: 'feedbackSuccess',
        meta: {
          title: '反馈成功',
          permissions: ['PHONE_CLIENT_MAP', 'PHONE_VISIT_CLIENT_MAP']
        }
      }
    ]
  },
  {
    path: '/personal-detials',
    name: 'PersonalDetials',
    component: () => import('@/views/terminal/PersonalDetails'),
    meta: {
      title: '个人中心',
      keepAlive: false,
      noRequiresAuth: true,
      permissions: ['PHONE_USER_INFO']
    }
  },
  {
    path: '/purchase-sell-stock',
    name: 'PurchaseSellStock',
    component: () => import('@/views/tenant/tjls/purchase-sell-stock'),
    meta: {
      title: '进销存平衡',
      unClick: true,
      noRequiresAuth: true,
      permissions: ['PHONE_PURCHASE_SELL_STOCK_TJLS']
    }
  },
  {
    path: '/real-time-screen',
    name: 'RealTimeScreen',
    component: () => import('@/views/tenant/tjls/real-time-screen'),
    meta: {
      title: '实时大屏',
      unClick: true,
      noRequiresAuth: true,
      permissions: ['PHONE_REAL_TIME_SCREEN_TJLS']
    }
  },
  {
    path: '/terminal-sales-analysis',
    name: 'TerminalSalesAnalysis',
    component: () => import('@/views/tenant/tjls/terminal-sales-analysis'),
    meta: {
      title: '终端销售',
      keepAlive: true,
      isUseCache: false,
      noRequiresAuth: true,
      permissions: ['PHONE_TERMINAL_SALES_ANALYSIS_TJLS']
    }
  },
  {
    path: '/form-table-detail',
    name: 'FormTableDetail',
    component: () => import('@/views/tenant/tjls/components/FormTableDetail'),
    meta: {
      title: '详情',
      keepAlive: true,
      permissions: ['PHONE_FLOW_LIST_TJLS']
    }
  },
  {
    path: '/edit-password',
    name: 'EditPassword',
    component: () => import('@/views/terminal/EditPassword'),
    meta: {
      title: '修改密码',
      noRequiresAuth: true,
      permissions: ['PHONE_USER_INFO']
    }
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/sign',
    component: () => import('@/components/TransferRouter'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => AsyncComponent(import('@/views/sign/Login')),
        meta: {
          title: '登录页',
          noRequiresAuth: true // 无需登录
        }
      },
      {
        path: 'reset',
        name: 'resetPassword',
        component: () => AsyncComponent(import('@/views/sign/ResetPassword')),
        meta: {
          title: '首次登录验证',
          noRequiresAuth: true // 无需登录
        }
      },
      {
        // 修改密码
        path: 'update',
        component: () => AsyncComponent(import('@/views/sign/UpdatePassword')),
        name: 'updatePassword',
        meta: {
          title: '修改密码页'
        }
      }
    ]
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('@/components/NotFound'),
    meta: {
      title: '404页面',
      noRequiresAuth: true // 无需登录
    }
  }
]

// 着陆页
export const systemPage = [
  {
    path: '/',
    component: () => AsyncComponent(import('@/views/terminal')),
    name: 'index',
    meta: {
      keepAlive: false,
      isUseCache: false, // 不使用缓存
      title: '健民集团DSS系统'
    }
  }
]
